import { CheckSquare, FolderPlus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LABEL, ROW_TITLE } from "@/lib/typography";
import { cn } from "@/lib/utils";

interface SelectionActionBarProps {
  selectedCount: number;
  loadedCount: number;
  allLoaded: boolean;
  onSelectAllLoaded: () => void;
  onDeselectAll: () => void;
  onAddToCollection: () => void;
  onCancel: () => void;
}

export function SelectionActionBar({
  selectedCount,
  loadedCount,
  allLoaded,
  onSelectAllLoaded,
  onDeselectAll,
  onAddToCollection,
  onCancel,
}: SelectionActionBarProps) {
  const allSelected = selectedCount >= loadedCount && loadedCount > 0;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-30 pointer-events-none"
      style={{ paddingBottom: "var(--above-bottom-nav)" }}
    >
      <div className="mx-auto max-w-lg px-3 pb-2 pointer-events-auto">
        <div className="flex items-center gap-2 rounded-2xl border bg-background/95 px-3 py-2.5 shadow-lg backdrop-blur supports-[backdrop-filter]:bg-background/80">
          {/* Cancel */}
          <button
            type="button"
            onClick={onCancel}
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-muted"
          >
            <X className="h-4 w-4" />
          </button>

          {/* Count + Select All */}
          <div className="flex flex-1 items-center gap-2 min-w-0">
            <span className={cn(ROW_TITLE, "tabular-nums")}>
              {selectedCount} selected
            </span>
            <button
              type="button"
              onClick={allSelected ? onDeselectAll : onSelectAllLoaded}
              className={cn(LABEL, "flex items-center gap-1 text-primary transition-opacity hover:opacity-80")}
            >
              <CheckSquare className="h-3 w-3" />
              {allSelected ? "Deselect" : "All"}
            </button>
          </div>

          {/* Add to Collection */}
          <Button
            variant="gradient"
            size="sm"
            onClick={onAddToCollection}
            disabled={selectedCount === 0}
            className="gap-1.5 shrink-0"
          >
            <FolderPlus className="h-3.5 w-3.5" />
            Save to Collection
          </Button>
        </div>
      </div>
    </div>
  );
}
